import styled from 'styled-components';
import { matchColorsBanner } from 'utils/colors'

export const StyledBannerMSJ = styled.div`
    width:100%;
    height: 30px;
    background-color: ${({$themeCustom}) => $themeCustom.details.colors.banner};
    color: ${({$themeCustom}) => matchColorsBanner($themeCustom.details.colors.banner)};
    display: flex;
    align-items: center; 
    justify-content: center;
    gap: 4px;
    text-align: center;
    
    p {
        margin-bottom: 0.3125rem;
        font-size: 0.75rem;
    }
`;
